import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import RetailersList from "components/menu/master-files/retailers/list";

const RetailersRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={RetailersList}
            />
        </Switch>
    </div>
);

export default connect()(RetailersRouter);
